import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
// import store from './store'
// import * as COMMONS from '../store/_commons'
import Home from '../views/Home.vue'
import QuoteLookup from '@/views/quote/QuoteLookup'
import QuoteEstimate from '@/views/quote/QuoteEstimate'
import VehicleLookup from '@/views/vehicle/VehicleLookup'
import VehicleStatus from '@/views/vehicle/VehicleStatus'
import PageNotFound from '@/views/PageNotFound'
import networkUtils from '@/utils/networkUtils'
import GuestSignin from '@/views/guestLogin/GuestLogin'
import Profile from '@/views/profile/Profile'
import RenewReg from '@/views/renewReg/RenewReg'
import DuplicateReg from '@/views/duplicateReg/DuplicateReg'
import CancelReg from '@/views/cancelReg/CancelReg'
import MultiFactAuth from '@/views/multiFactorAuth/MultiFactAuth'
import ContactInfo from '@/views/contactInfo/ContactInfo'
import AddressInfo from '@/views/addressInfo/AddressInfo'

Vue.use(VueRouter)

Vue.use(VueMeta, {
  // component option name that vue-meta looks for meta info on
  keyName: 'page'
});

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/fee-lookup',
    name: 'QuoteLookup',
    component: QuoteLookup
  },
  {
    path: '/fee-estimate',
    name: 'QuoteEstimate',
    component: QuoteEstimate
  },
  {
    path: '/vehicle-lookup',
    name: 'VehicleLookup',
    component: VehicleLookup
  },
  {
    path: '/vehicle-status',
    name: 'VehicleStatus',
    component: VehicleStatus
  },
  {
    path: '/404',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/guest-signin',
    name: 'GuestSignin',
    component: GuestSignin,
    meta: {disallowAuthed : true},
  },
  {
    path: '/mfa',
    name: 'MultiFactAuth',
    component: MultiFactAuth,
    meta: {disallowAuthed : true},
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    // meta: {auth : true},
    
    
    beforeEnter: (to, from, next) => {
      let storeGetter = router.app.$store.getters;
      if(storeGetter['guestLogin/statusInfo'].accessToken == '') {
        sessionStorage.clear();
        localStorage.clear();
        next ({name : 'GuestSignin'})
      }
      else {
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;
        next ();
      }
    }
    
  },
  {
    path: '/update-contacts',
    name: 'UpdateContacts',
    component: ContactInfo,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/update-address',
    name: 'UpdateAddress',
    component: AddressInfo,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/renew-reg',
    name: 'RenewReg',
    component: RenewReg,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/duplicate-reg',
    name: 'DuplicateReg',
    component: DuplicateReg,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/cancel-reg',
    name: 'CancelReg',
    component: CancelReg,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  }
  
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,    // scroll to anchor
      }
    } else {
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    }
  },
  routes
});

router.beforeEach(async (to, from, next) => {  
  if (!to.matched.length) {                 // 404
    console.warn('[Route Guard] Not found:', to);
    next({ name: 'PageNotFound' });
  } else if (to.name === 'VehicleStatus' && from.name !== 'VehicleLookup') {
    // user will have to enter vehicle info if they want to check status again
    next( { name: 'VehicleLookup' });
  } else {
    networkUtils.validateBrowser();
    networkUtils.transitionNetworkStatus();
    next();
  }
});

export default router
